import * as React from "react";
import { SVGProps, memo } from "react";

const SvgBlueClinic = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.417 4.25c0-.69.56-1.25 1.25-1.25h6.666c.69 0 1.25.56 1.25 1.25v3.333h1.667c.69 0 1.25.56 1.25 1.25v7.917c0 .69-.56 1.25-1.25 1.25H3.75c-.69 0-1.25-.56-1.25-1.25V8.833c0-.69.56-1.25 1.25-1.25h1.667V4.25Zm7.916 0H6.667v3.958c0 .346-.28.625-.625.625H3.75v7.917h3.958v-3.542c0-.69.56-1.25 1.25-1.25h2.084c.69 0 1.25.56 1.25 1.25v3.542h3.958V8.833h-2.292a.625.625 0 0 1-.625-.625V4.25Zm-2.291 8.958v3.542H8.958v-3.542h2.084ZM10 10.292a.625.625 0 0 1-.625-.625v-.834h-.833a.625.625 0 1 1 0-1.25h.833V6.75a.625.625 0 1 1 1.25 0v.833h.833a.625.625 0 1 1 0 1.25h-.833v.834c0 .345-.28.625-.625.625Z"
      fill="#1395EC"
    />
  </svg>
);

const Memo = memo(SvgBlueClinic);

export default Memo;
